import {Box, Card, CardContent, FormControl, InputLabel, MenuItem, Select, Typography} from "@mui/material";

const ProcessorSelector = ({processorType, onChange, isSubmitting}) => {
  return (
    <Card variant="outlined" sx={{height: "100%"}}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          ⚙️ Tipo de Procesador
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Selecciona el tipo de procesador que deseas utilizar para el análisis
        </Typography>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="processor-type-label">Procesador</InputLabel>
          <Select
            labelId="processor-type-label"
            id="processor-type-select"
            value={processorType}
            onChange={onChange}
            label="Procesador"
            disabled={isSubmitting}
          >
            <MenuItem value="ts">AI TeamSystem</MenuItem>
            <MenuItem value="gemini">AI Gemini</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{mt: 2, p: 2, bgcolor: "info.50", borderRadius: 1, border: 1, borderColor: "info.200"}}>
          <Typography variant="caption" color="textSecondary">
            <strong>Procesador seleccionado:</strong> {processorType}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProcessorSelector;
